export const numberFilterParams = {
    numberParser: (text: string | null) => {
        return text == null
            ? null
            : parseFloat(text);
    },
    buttons: ['reset']
};